export default __webpack_public_path__ + "static/media/down_dark.25102798.png";